import styled from "styled-components";

import ConfirmModal from "components/ConfirmModal";
import font from "constants/font";

const Message = styled.p`
  font-size: ${font.size16};
  text-align: center;
`;

/**
 * Names the action the switch is about to take, for titles and completion messages.
 *
 * @param searchStatus search status the order is in before the switch
 * @returns 再開 while the search is stopped, otherwise 停止
 * @example
 * setInfoModalTitle(`検索を${searchStatusActionLabelOf(order.searchStatus)}しました`);
 */
export const searchStatusActionLabelOf = (searchStatus?: ConstructionSearchStatus): "再開" | "停止" =>
  searchStatus === "STOP" ? "再開" : "停止";

/**
 * Confirmation asked before the search status switch takes effect.
 *
 * @param searchStatus search status the order is in before the switch
 * @param isVisible whether the confirmation is open
 * @param onClose called when the user backs out
 * @param onConfirm called when the user confirms stopping or resuming the search
 * @returns the confirmation modal
 * @example
 * <SearchStatusConfirmModal
 *   searchStatus={order.searchStatus}
 *   isVisible={isOpen}
 *   onClose={close}
 *   onConfirm={switchSearchStatus}
 * />
 */
const SearchStatusConfirmModal = ({
  searchStatus,
  isVisible,
  onClose,
  onConfirm,
}: {
  searchStatus?: ConstructionSearchStatus;
  isVisible: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}) => {
  const actionLabel = searchStatusActionLabelOf(searchStatus);

  return (
    <ConfirmModal
      isVisible={isVisible}
      title={`検索を${actionLabel}しますか？`}
      message={
        actionLabel === "再開" ? (
          <Message>
            駐車場の検索を再開すると
            <br />
            この依頼の見積提案が届くようになります
          </Message>
        ) : (
          <Message>
            駐車場の検索を停止すると
            <br />
            この依頼の見積提案が届かなくなります
          </Message>
        )
      }
      confirmButtonLabel={`${actionLabel}する`}
      onClose={onClose}
      onClick={onConfirm}
    />
  );
};

export default SearchStatusConfirmModal;
